export const CONSULTOR_FILTER_ALL = "todos";
export const CONSULTOR_FILTER_NONE = "__sem__";

export const emptyForm = {
  condominio: "",
  tipo: "residencial",
  infra_status: "atendido",
  qtd_apartamentos: 0,
  qtd_clientes_atuais: 0,
  responsavel: "",
  consultor: "",
  status_contato: "telefone",
  semana_planejada: "",
  meta_vendas: 0,
  vendas_realizadas: 0,
  meta_clientes_total: 0,
  meta_clientes_mensal: 0,
  data_aprovacao_prevista: "",
  observacoes: "",
  cnpj: "",
  endereco: "",
  complemento: "",
  contatos: [],
};

export const newContato = () => ({
  id: (globalThis.crypto?.randomUUID?.() || `c-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`),
  nome: "",
  cargo: "",
  telefone: "",
  celular: "",
  email: "",
  observacao: "",
});

export const CARGO_SUGERIDOS = ["Síndico(a)", "Sub-síndico(a)", "Zelador(a)", "Conselheiro(a)", "Administradora", "Portaria", "Comercial", "Outro"];

export const CONSULTOR_NONE = "__none__";  // valor sentinela — Select do shadcn não aceita value=""

export const STATUS_LABEL = { telefone: "Telefone", presencial: "Presencial", agendado: "Agendado" };

// Opções do filtro por % da meta atingida — combinações "abaixo/acima" x threshold.
export const META_FILTER_ALL = "todos";
export const META_THRESHOLDS = [30, 50, 70, 90, 100];
export const META_FILTER_OPTIONS = [
  { value: META_FILTER_ALL, label: "Todas as metas" },
  ...META_THRESHOLDS.flatMap((t) => [
    { value: `abaixo_${t}`, label: `Abaixo de ${t}% da meta` },
    { value: `acima_${t}`, label: `Acima de ${t}% da meta` },
  ]),
];

// ---------- Validação e formatação de CNPJ ----------
export const onlyDigits = (v) => String(v || "").replace(/\D/g, "");
export const formatCNPJ = (v) => {
  const d = onlyDigits(v).slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
};
export const isValidCNPJ = (v) => {
  const d = onlyDigits(v);
  if (d.length !== 14) return false;
  if (/^(\d)\1+$/.test(d)) return false;
  const calc = (base) => {
    const nums = d.slice(0, base).split("").map(Number);
    let pesos = base === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const soma = nums.reduce((s, n, i) => s + n * pesos[i], 0);
    const r = soma % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return calc(12) === Number(d[12]) && calc(13) === Number(d[13]);
};
